import { createPdfComposer } from "../../_CORE/APP/Templates/_UI/Pdf/PdfComposer";
import { requestPdfExportAppearance } from "../../_CORE/APP/Templates/_UI/Pdf/PdfExportAppearance";

const onSafeFileName = (value = "credencial") => String(value || "credencial")
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-zA-Z0-9._-]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 90) || "credencial";

const onStripHtml = (value) => {
    if (!value) return "";
    const element = window.document.createElement("div");
    element.innerHTML = String(value);
    return (element.textContent || element.innerText || "").trim();
};

const onRowsToText = (title, rows = []) => {
    const lines = [title, "", ...rows.flatMap(({ label, value }) => {
        const text = value == null ? "" : String(value);
        if (!text) return [];
        const parts = text.replace(/\r/g, "").split("\n");
        return parts.map((part, index) => index === 0 ? `${label}: ${part}` : `  ${part}`);
    })];
    return `${lines.join("\n").trim()}\n`;
};

const onDownloadBlob = (blob, fileName) => {
    const url = window.URL.createObjectURL(blob);
    const link = window.document.createElement("a");
    link.href = url;
    link.download = fileName;
    window.document.body.appendChild(link);
    link.click();
    window.document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
};

export const downloadCredentialTxt = ({ title, rows, fileName = title }) => {
    const content = onRowsToText(title, rows);
    onDownloadBlob(new Blob([content], { type: "text/plain;charset=utf-8" }), `${onSafeFileName(fileName)}.txt`);
};

export const downloadCredentialPdf = async ({ title, rows = [], fileName = title, appearance = null }) => {
    const style = appearance || await requestPdfExportAppearance({ title: title || "Credencial" });
    if (!style) return false;

    const pdf = createPdfComposer({ appearance: style, documentTitle: title || "Credencial" });
    pdf.addTitle(title || "Credencial");
    pdf.addMeta(`${rows.filter((row) => String(row?.value ?? "").trim()).length} campos incluidos · ${new Date().toLocaleString("es-AR")}`);
    pdf.addRule({ after: 10 });

    rows.forEach(({ label, value }) => {
        const text = value == null ? "" : String(value);
        if (!text.trim()) return;
        pdf.addLabelValue(label || "Campo", text);
    });

    const bytes = pdf.finish();
    onDownloadBlob(new Blob([bytes], { type: "application/pdf" }), `${onSafeFileName(fileName)}.pdf`);
    return true;
};

export { onStripHtml };
